import { Spinner } from "@chakra-ui/react";

const LoadingSpinner = ({ size }) => {
  return (
    <Spinner
      speed="0.65s"
      color="brand.900"
      size={size}
      thickness={size === "xl" ? "4px" : undefined}
    />
  );
};

export default LoadingSpinner;
